<ng-template let-view>
    <cer-grid
      #list
      [id]="view.id"
      [formView]="view"
      [viewMetadata]="view.viewMetadata"
      [dataParent]="view.dataParent"
      [dataChild]="view.dataChild"
      [dataChildOfIds]="view.dataChildOfIds"
      [fieldGroupMetadata]="view.fieldGroupMetadata"
      [fieldMetadata]="view.fieldMetadata"
      [toolbarType]="view.toolbarType"
      [toolbarTitle]="view.titleHeaderVisible === true ? 'disabled' : 'default'"
      [toolbarCommands]="view.toolbarCommands"
      [contextMenuCommands]="view.contextMenuCommands"
      [autoFocus]="view.autoFocus"
      [selectionMode]="view.listSelectionMode"
      [paging]="view.listPaging"
      [editSettings]="view.listEditSettings"
      (commmand)="onComponentCommand($event)">
    </cer-grid>
</ng-template>
